<template>
  <div class="embedded-recording">
    <a v-if="productInfo" :href="productInfo.href" target="_blank" class="product-info">
      <img :src="productInfo.logoSrc"/>
    </a>
    <error-ui v-if="error" :error="error" class="text-center"></error-ui>
    <router-view v-else></router-view>
    <event-capture></event-capture>
    <tangram-event-capture></tangram-event-capture>
  </div>
</template>

<script>
import g2sRecording from '@/store/modules/g2s-recording';
import recording from '@/store/modules/recording';
import ErrorUi from '@/components/error-ui';
import EventCapture from "./event-capture";
import TangramEventCapture from "./tangram-event-capture";

const EmbeddedRecording = {
    name: 'EmbeddedRecording',

    async beforeCreate() {
      await this.$store.registerModule('g2sRecording', g2sRecording);
      if (!this.$store.state.recording) {
        await this.$store.registerModule('recording', recording);
      }
    },
    components: {
      EventCapture,
      TangramEventCapture,
      ErrorUi
    },
    computed: {
      error() {
        return this.$store.state.error;
      },
      productInfo() {
        return this.$store.getters['g2sRecording/productInfo'];
      }
    }
}

export default EmbeddedRecording;
</script>

<style lang="sass" scoped>
  .embedded-recording
    height: 100%

    &:hover .product-info
      z-index: 1


    .product-info
      position: absolute
      left: 12px
      top: 13px

      img
        width: 80%
</style>
